import React from "react";
import { FaUserSecret, FaTimes } from "react-icons/fa";

interface ImpersonatedUser {
  id: string;
  email: string;
  name: string;
}

interface ImpersonationBannerProps {
  impersonatedUser: ImpersonatedUser;
  onStopImpersonating: () => void;
}

/**
 * A sticky banner that displays when an admin is impersonating another user.
 * Shows the impersonated user's info and provides a button to stop impersonating.
 */
const ImpersonationBanner: React.FC<ImpersonationBannerProps> = ({
  impersonatedUser,
  onStopImpersonating,
}) => {
  return (
    <div className="bg-gradient-to-r from-amber-500 to-orange-500 text-white px-4 py-2 flex items-center justify-between shadow-md z-50">
      <div className="flex items-center gap-3">
        <FaUserSecret className="text-xl animate-pulse" />
        <span className="font-medium">
          Vous êtes en train d'impersonner:{" "}
          <strong className="font-bold">
            {impersonatedUser.name || impersonatedUser.email}
          </strong>
          {impersonatedUser.name && (
            <span className="opacity-80 ml-1">({impersonatedUser.email})</span>
          )}
        </span>
      </div>
      <button
        onClick={onStopImpersonating}
        className="flex items-center gap-2 bg-white/20 hover:bg-white/30 transition-colors px-4 py-1.5 rounded-lg font-medium"
      >
        <FaTimes />
        <span>Arrêter l'impersonation</span>
      </button>
    </div>
  );
};

export default ImpersonationBanner;
